// extracted by mini-css-extract-plugin
module.exports = {"header":"_1Qipi","title":"_1YNff","arrow":"SnATe","divider":"ICBV3","details":"_1Eglk","checkbox":"_2Ew4e","form":"R73zR","editable":"yGmx1","expanded":"_2AHGo","filled":"_2JyHq"};